<app-sidebar [loading]="loading$ | async" [option]="option$ | async" [options]="options$ | async"
    (optionSelected$)="navigateToOption($event)">
</app-sidebar>